<template>
  <f-form-group
    v-if="field_visible"
    :field-errors="fieldErrors"
    :required="field.required"
    :label="field_label"
    :hide-label="hideLabel"
    :horizontal="horizontal"
    v-b-tooltip="tooltip"
  >
    <o-flatpickr-wrapper
      :disabled="is_disabled || field_disabled"
      :hide-date="!field.params.input_date"
      :hide-time="!field.params.input_time"
      :value="field_value"
      @input="on_input"
      nolabel
      v-bind="field.params"
    >
    </o-flatpickr-wrapper>
  </f-form-group>
</template>

<script>
import FormWidgetMixin from "../FormWidgetMixin.js";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime.vue";
import OFlatpickrWrapper from "../../../vue-ocom/components/forms/fields/private/OFlatpickrWrapper.vue";
import FFormGroup from "../FFormGroup.vue";

export default {
  name: "DatetimeWidget",
  components: { FFormGroup, OFlatpickrWrapper, ODateTime },
  mixins: [FormWidgetMixin],
  computed: {
    field_disabled() {
      return this.field.disabled;
    },
  },
};
</script>
